import file from './src/file'

export default file



// WEBPACK FOOTER //
// ./src/components/file/index.js